export const getUpdatedParts = (parts, partItems) => {
  let updatedPartItems = [];
  parts?.filter(part => {
    partItems?.map(item => {
      if (item.itemNumber.toUpperCase() === part?.partNumber.toUpperCase()) {
        updatedPartItems.push({
          itemNumber: part.itemNumber,
          partNumber: item.itemNumber,
          quantity: item.quantity,
          assetId: item.assetId,
          id: item.id
        });
      }
      return updatedPartItems;
    });
    return null;
  });
  return updatedPartItems;
};
export const getParts = sisImportValidAndInvalidParts => {
  return Object.keys(sisImportValidAndInvalidParts).map(key => {
    return {
      ...sisImportValidAndInvalidParts[key],
      partNumber: key
    };
  });
};
